import { createContext, useContext, type ReactNode } from 'react';

interface ReportPersonnelContextValue {
  companyId: string | null;
  companyName: string | null;
  siteId: string | null;
  openPersonnelManager: () => void;
}

const ReportPersonnelContext = createContext<ReportPersonnelContextValue | null>(null);

export function ReportPersonnelProvider({
  value,
  children,
}: {
  value: ReportPersonnelContextValue;
  children: ReactNode;
}) {
  return (
    <ReportPersonnelContext.Provider value={value}>{children}</ReportPersonnelContext.Provider>
  );
}

export function useReportPersonnelContext(): ReportPersonnelContextValue {
  const context = useContext(ReportPersonnelContext);
  if (!context) {
    throw new Error('ReportPersonnelContext missing in component tree');
  }
  return context;
}
